var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeExpertiseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_890_926)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.3235 5.32781L23.2576 -0.488037C23.0517 -0.55835 22.7755 -0.593506 22.4992 -0.593506C22.223 -0.593506 21.9468 -0.55835 21.7409 -0.488037L4.67503 5.32781C4.25817 5.46844 3.91666 5.95058 3.91666 6.39254V30.6202C3.91666 31.0622 4.20293 31.6448 4.54947 31.921L21.8614 45.411C22.0372 45.5466 22.2632 45.6169 22.4942 45.6169C22.7253 45.6169 22.9563 45.5466 23.127 45.411L40.439 31.921C40.7855 31.6498 41.0718 31.0672 41.0718 30.6202V6.39254C41.0818 5.95058 40.7403 5.47346 40.3235 5.32781ZM37.4658 29.6559L22.4992 41.3178L7.53273 29.6559V8.18049L22.4992 3.07781L37.4658 8.18049V29.6559ZM17.0852 19.5611C16.9345 19.3552 16.6934 19.2296 16.4323 19.2296H13.66C13.3335 19.2296 13.1427 19.6012 13.3335 19.8674L19.6817 28.6063C19.7568 28.709 19.855 28.7926 19.9685 28.8502C20.0819 28.9078 20.2074 28.9378 20.3346 28.9378C20.4619 28.9378 20.5873 28.9078 20.7008 28.8502C20.8142 28.7926 20.9125 28.709 20.9875 28.6063L31.665 13.9059C31.8558 13.6398 31.665 13.2681 31.3385 13.2681H28.5662C28.3101 13.2681 28.064 13.3937 27.9133 13.5996L20.3346 24.036L17.0852 19.5611Z",
    fill: "#5CBF14"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_890_926"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeExpertiseIcon);
export default __webpack_public_path__ + "static/media/home-expertise-icon.04cc8a7924cd4e84e891afbf656c8296.svg";
export { ForwardRef as ReactComponent };